import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";

import { ActionButtonComponent } from "../../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-disable-mfa",
	templateUrl: "./disable-mfa.component.html",
	styleUrls: ["./disable-mfa.component.scss"],
	imports: [FormsModule, ActionButtonComponent]
})
export class DisableMfaComponent {
	private router = inject(Router);
	private api = inject(ApiService);

	public mfa_code: string;
	public errormessage: string;

	async DisableMFA() {
		if (!this.mfa_code) throw new Error("MFA code is required");
		await this.api.DisableMFA(this.mfa_code);
		setTimeout(() => {
			this.router.navigate(["/dash/account"]);
		}, 1000);
	}
}
